import styled from 'styled-components'
import { Font14, Font16 } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'

export const TextWithShowMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TextWithShowMoreBody = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  ${Font14};
  line-height: 22px;
`

export const TextWithShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const TextWithShowMoreButton = styled(CommonLinkButton)`
  ${Font16};
  text-transform: capitalize;
  color: ${theme.colors.horizonOrange};
  width: 100%;
`
